import React, { type MouseEventHandler, useState } from 'react';

import TemplateActionsMenu from '@dashboard/components/TemplateActionsMenu';
import { MoreHorizOutlined } from '@mui/icons-material';
import { IconButton, Tooltip } from '@mui/material';

type Props = {
  templateId: string;
};
export default function ActionsMenu({ templateId }: Props) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const handleClick: MouseEventHandler<HTMLElement> = (event) => {
    event.stopPropagation();
    event.preventDefault();
    setAnchorEl(event.currentTarget);
  };

  return (
    <>
      <Tooltip title="Additional actions">
        <span>
          <IconButton type="button" size="small" onClick={handleClick} color="inherit">
            <MoreHorizOutlined fontSize="small" />
          </IconButton>
        </span>
      </Tooltip>
      <TemplateActionsMenu redirect anchorEl={anchorEl} setAnchorEl={setAnchorEl} templateId={templateId} />
    </>
  );
}
